const isProd = () => {
  try {
    return (
      typeof window !== 'undefined' &&
      !window.location.href.includes('localhost') &&
      !window.location.href.includes('fns.dev') &&
      !window.location.href.includes('fns.test') &&
      !window.location.href.includes('fns.staging')
    );
  } catch {
    return false;
  }
};

export const devLog = (...args) => {
  if (!isProd()) console.log(...args);
};
export const devWarn = (...args) => {
  if (!isProd()) console.warn(...args);
};
export const devError = (...args) => {
  if (!isProd()) console.error(...args);
};
